<template>
  <div class="cmp-elastic-product-details utlz-reset utlz-row">
    <!-- BESPOKE DEPA-31: Changed class to col-md-5 -->
      <div class="utlz-col-md-5 column-left">
        <!-- END BESPOKE DEPA-31 -->
        <utlz-gallery :product="productDetails"></utlz-gallery>
      </div>
      <!-- BESPOKE DEPA-31: Changed class to col-md-7 -->
      <div class="utlz-col-md-7 column-right product-details-column">
        <!-- END BESPOKE DEPA-31 -->
          <div class="product-information">
            <!-- BESPOKE DEPA-36: Added product.subTitle -->
            <div class="product-code">
                <span>{{productDetails.id}}</span>
            </div>
            <h1>{{productDetails.shortDescription}}</h1>
            <h2 class="subtitle" v-if="productDetails.subTitle">{{ productDetails.subTitle }}</h2>
            <!-- END BESPOKE DEPA-36 -->
            <div class="ph-product-price" v-if="productDetails.prices.length">
                <utlz-product-price
                    :prices="productDetails.prices[0]"
                ></utlz-product-price>
            </div>

            <utlz-tabs :tabs="tabs">

              <template v-slot:description>
                <div class="prod-desc-container" :class="{'expandable': useCollapse, 'expanded': expanded  }">
                  <div ref="productDescription" class="prod-desc-wrapper">
                    <div class="product-long-description" v-html="productDetails.longDescription">
                    </div>
                  </div>
                </div>
                <a v-if="useCollapse" @click="expanded = !expanded" class="collapse-button theme-primary">
                  <div v-if="!expanded" class="read-more">
                    <span v-translation="{ type: 'button', code: 'link_description_read_more' }"></span>
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </div>
                  <div v-if="expanded" class="read-less">
                    <span v-translation="{ type: 'button', code: 'link_description_read_less' }"></span>
                    <i class="fa fa-angle-up" aria-hidden="true"></i>
                  </div>
                </a>
              </template>

              <template v-slot:description2>
                <div class="prod-desc2-container" :class="{'expandable': useCollapse, 'expanded': expanded  }">
                  <div ref="productDescription2" class="prod-desc2-wrapper">
                    <div class="product-long-description2" v-html="longDescription2">
                    </div>
                  </div>
                </div>
                <a v-if="useCollapse" @click="expanded = !expanded" class="collapse-button theme-primary">
                  <div v-if="!expanded" class="read-more">
                    <span v-translation="{ type: 'button', code: 'link_description_read_more' }"></span>
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </div>
                  <div v-if="expanded" class="read-less">
                    <span v-translation="{ type: 'button', code: 'link_description_read_less' }"></span>
                    <i class="fa fa-angle-up" aria-hidden="true"></i>
                  </div>
                </a>
              </template>



              <template v-slot:videos>
                <div class="product-videos" v-if="videos.length">
                  <utlz-product-videos :videos="videos"></utlz-product-videos>
                </div>
              </template>

              <template v-slot:documents v-if="documents.length">
                <div class="product-documents">
                  <utlz-product-documents :documents="documents"></utlz-product-documents>
                </div>
              </template>
            </utlz-tabs>

            <div class="product-specifications">
              <h2 v-translation="{ type: 'title', code: 'title_specifications' }"></h2>
              <div class="spec-list">
                <div class="spec-item" v-for="prop in productProperties" :key="prop.key">
                  <div class="spec-desc">
                    {{prop.key}}
                  </div>
                  <div class="spec-value">
                    {{prop.value}}
                  </div>
                </div>
              </div>
            </div>

            <utlz-group-dropdown :variants="productVariants" />

            <!-- BESPOKE DEPG-31: Added placeholder for the calculator -->
            <div id="ph-calculator"></div>
            <!-- END BESPOKE DEPG-31 -->

            <!-- BESPOKE DEPA: Only show stock if product has customBooleans.STOCK_PRODUCT === true -->
            <utlz-product-stock
              v-if="productDetails.customBooleans.STOCK_PRODUCT"
              :product="productDetails"
              :stock="productDetails.stock"
              :stockTotal="productDetails.stock"
            ></utlz-product-stock>
            <!-- END BESPOKE DEPA -->

            <!-- BESPOKE DEPU-2: Add extra field on UK portal -->
            <template v-if="bespokeGlobalWs.shopName === 'uk' || bespokeGlobalWs.shopName === 'de'">
              <div v-if="productStocked.length" class="prod-stocked-label" :class="{'label-green': productStocked.includes('UK') || productStocked.includes('DEU') }">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                {{ productStocked }}
              </div>
            </template>
            <!-- END BESPOKE DEPU-2 -->

            <!-- BESPOKE DEPG-31: Added :useTextButton="true", :useCalculationBox, useCanopyCalculator and removed productDetails.prices.length -->
            <div class="order-product">
              <utlz-order-product
                v-if="showOrderProductControl"
                :useQuoteButtonText="true"
                :product="productDetails"
                :useTextButton="true"
                :useOrderComment="showOrderComment"
                :useCalculationBox="productDetails.customBooleans.CUSTOM_GLAS_PROD"
                :useCanopyCalculator="productDetails.customBooleans.CUSTOM_CANOPY_PROD"
                >
                </utlz-order-product>

                <!-- BESPOKE DEPA: Hide out of stock message -->
                <!-- <transition name="fade">
                  <p v-if="!showOrderProductControl && showStock" class="out-of-stock-msg">
                    <i class="fa fa-warning"></i>
                    <span v-translation="{ type: 'label', code: 'label_out_of_stock' }"></span>
                  </p>
                </transition> -->
                <!-- END BESPOKE DEPA -->
            </div>
            <!-- END BESPOKE DEPG-31 -->

            <div class="favorite">
              <utlz-favorites-control v-if="showFavorites" :product="productDetails" :useDescription="true"></utlz-favorites-control>
            </div>
          </div>
      </div>

      <div class="utlz-col-12 margin-bottom-30"></div>

      <!-- BESPOKE DEPG-31: Disabled matrix -->
      <!-- <div v-if="showOrderProductControl && productDetails.prices.length && productVariants.length" class="utlz-col-md-12">
        <utlz-group-matrix :variants="productVariants" />
      </div> -->
      <!-- END BESPOKE DEPG-13 -->


      <!-- BESPOKE DEPA: Used custom control for the upselling products -->
      <!-- <div v-if="relatedProducts.upSelling.length" class="related-products upselling utlz-col-12 ">
        <utlz-product-carousel
          :products="relatedProducts.upSelling"
          :blockSize="relatedProductBlockSize"
          :title="titleUpSelling"
        ></utlz-product-carousel>        
      </div> -->      

      <!-- <div v-if="relatedProducts.crossSelling.length" class="related-products upselling utlz-col-12 ">
        <utlz-product-carousel
          :products="relatedProducts.crossSelling"
          :blockSize="relatedProductBlockSize"
          :title="titleCrossSelling"
        ></utlz-product-carousel>
      </div> -->
      <utlz-related-products-matrix 
        :products="relatedProducts.crossSelling"
        :customDecimals="productDetails.customDecimals"
      ></utlz-related-products-matrix>
      <!-- END BESPOKE DEPA -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ProductPrice from 'src/components/webshop/product-price/ProductPrice.vue';
import OrderProduct from 'src/components/webshop/order-product/OrderProduct.vue';
import ProductStock from 'src/components/webshop/product-stock/ProductStock.vue';
import ProductGroupMatrix from 'src/components/webshop/products/product-group/ProductGroupMatrix.vue';
import ProductGroupDropdown from 'src/components/webshop/products/product-group/ProductGroupDropdowns.vue';
import FavoritesControl from 'src/components/webshop/favorites/FavoritesControl.vue';
import Gallery from 'src/components/ui/gallery/Gallery.vue';
import Tabs from 'src/components/ui/tabs/Tabs.vue';
import ProductVideos from 'src/components/webshop/products/product-videos/ProductVideos.vue';
import ProductDocuments from 'src/components/webshop/products/product-documents/ProductDocuments.vue';
import ProductCarousel from 'src/components/webshop/products/product-carousel/ProductCarousel.vue';
// BESPOKE
import RelatedProductsMatrix from './../../../../bespoke-components/RelatedProductsMatrix.vue';
// END BESPOKE
export default {
  components: {
    'utlz-product-price': ProductPrice,
    'utlz-order-product': OrderProduct,
    'utlz-product-stock': ProductStock,
    'utlz-group-matrix': ProductGroupMatrix,
    'utlz-group-dropdown': ProductGroupDropdown,
    'utlz-favorites-control': FavoritesControl,
    'utlz-gallery': Gallery,
    'utlz-tabs': Tabs,
    'utlz-product-carousel': ProductCarousel,
    'utlz-product-videos': ProductVideos,
    'utlz-product-documents': ProductDocuments,
    // BESPOKE
    'utlz-related-products-matrix': RelatedProductsMatrix
    // END BESPOKE
  },
  data () {
    return {
      expanded: false,
      productDescriptionHeight: 0,
      titleUpSelling: window.vue.translations.title.title_product_relations,
      titleCrossSelling: window.vue.translations.title.title_product_relations_cross,
      tabs: [
        { id: 'description', description: window.vue.translations.label.label_tab_product_desc, active: true, visible: false },
        { id: 'description2', description: window.vue.translations.label.label_tab_product_desc2, active: false, visible: false },
        { id: 'documents', description: window.vue.translations.label.label_tab_product_documents, active: false, visible: false },
        { id: 'videos', description: window.vue.translations.label.label_tab_product_videos, active: false, visible: false }
      ]
    }
  },
  watch: {    
    longDescription(val) { this.tabs[0].visible = val.length > 0; },
    longDescription2(val) { this.tabs[1].visible = val.length > 0; },
    documents (val) { this.tabs[2].visible = val.length > 0; },
    videos (val) { this.tabs[3].visible = val.length > 0; } 
  },
  computed: {
    ...mapState('productDetails', ['productDetails', 'productVariants', 'relatedProducts', 'videos']),
    // BESPOKE DEPA
    // Added bespokeGlobalWs and language
    ...mapGetters([
      'showStock', 
      'showPrices', 
      'showFavorites', 
      'showOrderProduct', 
      'stockLimit', 
      'useOrderLineComments', 
      'relatedProductBlockSize', 
      'bespokeGlobalWs', 
      'language']),
    ...mapGetters('productDetails', ['documents']),
    // BESPOKE
    showOrderComment() {
      var customBools = this.productDetails.customBooleans;
      return customBools.SHOW_PROD_COMMENT && !customBools.CUSTOM_GLAS_PROD && !customBools.CUSTOM_CANOPY_PROD;
    },
    longDescription2() {
      let prodComm2 = this.productDetails.customStrings["PROD_COMM2_" + this.language];
      return prodComm2 !== undefined ? prodComm2 : "";
    },
    // END BESPOKE
    longDescription() {
      return this.productDetails.longDescription;
    },
    useCollapse () {
      return this.productDescriptionHeight > 150;
    },
    showOrderProductControl () {
      // BESPOKE DEPA
      // Show der product if user is logged in
      if (this.showOrderProduct) {
        return true;
      }
      // END BESPOKE DEPA
      if (!this.showPrices) {
        return false;
      } else if (this.showOrderProduct) {
        if (!this.stockLimit) {
          return true;
        } else if (this.stockLimit && this.productDetails.stock !== null) {
          return this.stockLimit && this.productDetails.stock.stockTotal > 0;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    productProperties () {
      return Object.keys(this.productDetails.properties).map(x => {
        return { key: x, value: this.productDetails.properties[x] }
      });
    },
    images () {
      let images = [];

      images.push(this.productDetails.imageUrl)

      this.productDetails.images.forEach(element => {
        images.push(element);
      });

      return images
    },
    // BESPOKE DEPU-2
    productStocked () {
      let productStocked = this.productDetails.customStrings["FF_DESC2_" + this.language];
      return productStocked !== undefined ? productStocked : "";
    }
    // END BESPOKE DEPU-2
  },
  updated () {
    if (this.$refs.productDescription !== undefined) {
      this.productDescriptionHeight = this.$refs.productDescription.clientHeight;
    }
  },
  mounted () {
    this.initDetails();
    // BESPOKE DEPA-31
    // Moved calculator to placheolder
    $('#ph-calculator').append($('.uc-calculation-tool'));
    // END BESPOKE DEPA-31
  },
  methods: {
    ...mapActions('productDetails', ['initDetails'])
  }
}
</script>

<style>

</style>
